var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Safe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-746.000000, -3150.000000)",
    fill: "#F81CA3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M758.114738,3150.79888 C761.932871,3150.3733 765.917084,3150 770,3150 C774.082916,3150 778.067129,3150.3733 781.885156,3150.79888 C787.830044,3151.46151 792.606578,3156.23396 793.243733,3162.18944 C793.650133,3165.98784 794,3169.94539 794,3174 C794,3178.05458 793.650133,3182.01212 793.243733,3185.81049 C792.606578,3191.76604 787.830044,3196.53867 781.885156,3197.20107 C778.067129,3197.62667 774.082916,3198 770,3198 C765.917084,3198 761.932871,3197.62667 758.114738,3197.20107 C752.170027,3196.53867 747.393451,3191.76604 746.756281,3185.81049 C746.349895,3182.01212 746,3178.05458 746,3174 C746,3169.94539 746.349895,3165.98784 746.756281,3162.18944 C747.393447,3156.23396 752.170027,3151.46151 758.114738,3150.79888 Z M780.381938,3166.75701 C781.291022,3165.93241 781.359289,3164.52704 780.534791,3163.61806 C779.710222,3162.70905 778.304853,3162.6406 777.39584,3163.46521 C774.442062,3166.14468 772.223253,3168.55275 770.350329,3171.47609 C768.986311,3173.60508 767.838044,3175.95712 766.713707,3178.80772 L762.706453,3174.67524 C761.852053,3173.79417 760.445191,3173.77252 759.564124,3174.62688 C758.683058,3175.48128 758.661404,3176.88814 759.515769,3177.76921 L765.980409,3184.43588 C766.517156,3184.98951 767.302471,3185.22524 768.055324,3185.05884 C768.808142,3184.89244 769.420978,3184.34763 769.674453,3183.61948 C771.16864,3179.32732 772.495111,3176.36711 774.092587,3173.87371 C775.68128,3171.39403 777.598044,3169.28242 780.381938,3166.75701 Z",
    id: "Safe"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafe);
export default __webpack_public_path__ + "static/media/safe.d571de18fbeb08afca80317b8bd7aaad.svg";
export { ForwardRef as ReactComponent };